module.exports = __webpack_public_path__ + "img/mw.43ff7ada.svg";